// This is an automatically-generated file. Do not modify manually.
// To regenerate this file, run yarn svg-icons or gradlew yarn_svg-icons.
import * as React from 'react'; // tslint:disable

export function SvgPrepDetailsChangesEdit(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width={16} height={16} {...props}>
      <g fill="#656666">
        <path d="M13.6 4.4l-1.7-1.7c-.3-.3-.7-.3-1 0L9.7 3.9l.7.7 1-1 1.3 1.3-1 1 .7.7 1.2-1.2c.2-.3.2-.8 0-1zM6.3 11.2L5 9.9l4.6-4.6-.7-.7L3.6 10l2.7 2.7 5.3-5.4-.7-.7zM2 14.2l3.3-.7L2.7 11z" />
      </g>
    </svg>
  );
}
